import Roueter from './Router';
function App() {

  return (
    <>
      <Roueter />
    </>
  );
}

export default App;
